import { NgModule } from '@angular/core';
import { EmergenciasRoutingModule } from './routing';

// Todos los componentes de Emergencias Médicas son standalone: el módulo sólo
// carga sus rutas.
@NgModule({
  imports: [EmergenciasRoutingModule],
})
export class EmergenciasModule {}
